import { render, staticRenderFns } from "./Intro.vue?vue&type=template&id=a85d959e&scoped=true"
import script from "./Intro.vue?vue&type=script&lang=js"
export * from "./Intro.vue?vue&type=script&lang=js"
import style0 from "./Intro.vue?vue&type=style&index=0&id=a85d959e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85d959e",
  null
  
)

export default component.exports